import React from 'react';

import type { DashboardPeriod } from '../types';

const OPTIONS: Array<{ id: DashboardPeriod; label: string }> = [
  { id: 'today', label: 'Heute' },
  { id: 'week', label: 'Woche' },
  { id: 'month', label: 'Monat' },
];

type DashboardPeriodToggleProps = {
  value: DashboardPeriod;
  onChange: (period: DashboardPeriod) => void;
};

export function DashboardPeriodToggle({ value, onChange }: DashboardPeriodToggleProps) {
  return (
    // Gleich hoch wie „+ Projekt“ (h-9); aktiv weiß hinterlegt wie die Reiter in der App.
    <div className="grid h-9 min-w-0 flex-1 grid-cols-3 items-stretch gap-0.5 rounded-md border border-app-border bg-app-surface-muted p-0.5 sm:inline-flex sm:min-w-fit sm:flex-none">
      {OPTIONS.map((option) => {
        const active = option.id === value;
        return (
          <button
            key={option.id}
            type="button"
            onClick={() => onChange(option.id)}
            className={`rounded px-2 text-center text-sm font-medium transition-colors sm:px-3 ${
              active ? 'bg-app-surface text-app-text shadow-sm ring-1 ring-app-border' : 'text-app-text-muted hover:text-app-text'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
